import React from 'react';
import { uploadsTableHeader } from '../constants/uploadsTableHeader';
import LibraryTableHeader from './LibraryTableHeader';

interface UploadsTableHeaderProps {
  sortField: string | null;
  sortDirection: 'asc' | 'desc' | null;
  onSort: (field: string) => void;
}

/**
 * Uploads table header - uses LibraryTableHeader with uploads config
 */
const UploadsTableHeader: React.FC<UploadsTableHeaderProps> = (props): JSX.Element => (
  <LibraryTableHeader columns={uploadsTableHeader} {...props} />
);

export default UploadsTableHeader;
